<template>
  <aside class="app-sidebar">
    <div class="sidebar-brand">
      <div class="sidebar-brand__inner">
        <div class="sidebar-brand__" />
        <span class="sidebar-brand__title" :title="orgName">{{ orgName }}</span>
      </div>
    </div>

    <nav class="sidebar-nav">
      <router-link
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        class="nav-item"
        :class="{ active: isNavActive(item.path) }"
      >
        <span class="nav-icon-wrap">
          <img
            :src="isNavActive(item.path) ? item.iconActive : item.icon"
            :alt="item.title"
            class="nav-icon"
          />
        </span>
        <span class="nav-title">{{ item.title }}</span>
      </router-link>
    </nav>

    <div class="sidebar-footer">
      <button type="button" class="logout-btn" @click="handleLogout">
        <svg
          class="logout-btn__icon"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 12.75L15.75 9L12 5.25"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.75 9H6.75"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="logout-btn__text">退出登录</span>
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { logout as logoutApi } from '@/api/memberAuth'
import { clearLoginSession, getDisposalBindOrgName } from '@/utils/auth'

import iconCenter from '@/assets/comimg/chuzhizhongxin.png'
import iconCenterActive from '@/assets/comimg/chuzhizhongxined.png'
import iconRecords from '@/assets/comimg/chuzhijilu.png'
import iconRecordsActive from '@/assets/comimg/chuzhijilued.png'
import iconFinance from '@/assets/comimg/caiwutongji.png'
import iconFinanceActive from '@/assets/comimg/caiwutongjied.png'
import iconProfile from '@/assets/comimg/gerenzhongxin.png'
import iconProfileActive from '@/assets/comimg/gerenzhongxined.png'

const route = useRoute()
const router = useRouter()
const currentRoute = computed(() => route.path)
const orgName = computed(() => getDisposalBindOrgName() || '处置公司')

const isNavActive = (path) => {
  if (path === '/disposal-center') {
    return currentRoute.value === path || currentRoute.value.startsWith('/disposal-center/')
  }
  return currentRoute.value === path
}

const navItems = [
  {
    path: '/disposal-center',
    title: '处置中心',
    icon: iconCenter,
    iconActive: iconCenterActive
  },
  {
    path: '/disposal-records',
    title: '处置记录',
    icon: iconRecords,
    iconActive: iconRecordsActive
  },
  {
    path: '/finance',
    title: '财务统计',
    icon: iconFinance,
    iconActive: iconFinanceActive
  },
  {
    path: '/profile',
    title: '个人中心',
    icon: iconProfile,
    iconActive: iconProfileActive
  }
]

const handleLogout = async () => {
  try {
    await logoutApi()
  } catch {
    // 忽略退出接口失败，仍清除本地登录态
  }
  clearLoginSession()
  router.push('/login')
}
</script>

<style scoped>
.app-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 236px;
  background: #fff;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 0;
  box-sizing: border-box;
}

.sidebar-brand {
  flex: none;
  align-self: stretch;
  padding: 0 0 32px;
  box-sizing: border-box;
}

.sidebar-brand__inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  height: 40px;
  box-sizing: border-box;
}

.sidebar-brand__logo {
  flex: none;
  width: 40px;
  height: 40px;
  background: #057bfa;
  border: 2px solid #057bfa;
  border-radius: 12px;
  box-sizing: border-box;
}

.sidebar-brand__title {
  flex: 1;
  min-width: 0;
  margin-left: 16px;
  font-family: 'HarmonyOS Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-nav {
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 16px 0;
  gap: 8px;
  box-sizing: border-box;
  overflow-y: auto;
}

.nav-item {
  flex: none;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  height: 48px;
  box-sizing: border-box;
  background: #fff;
  text-decoration: none;
  border-left: 4px solid transparent;
  transition: color 0.2s ease;
}

.nav-item:hover:not(.active) {
  background: #fafbfc;
}

.nav-item.active {
  height: 44px;
  border-left-color: #057bfa;
}

.nav-icon-wrap {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.nav-icon {
  display: block;
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.nav-item:nth-child(1) .nav-icon {
  width: 18px;
  height: 20px;
}

.nav-title {
  flex: none;
  font-family: 'HarmonyOS Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: #475569;
  white-space: nowrap;
}

.nav-item.active .nav-title {
  font-weight: 900;
  color: #057bfa;
}

.sidebar-footer {
  flex: none;
  align-self: stretch;
  border-top: 1px solid rgba(227, 191, 177, 0.15);
  padding: 24px 24px 0;
  box-sizing: border-box;
}

.logout-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 12px 0;
  gap: 8px;
  border: none;
  border-radius: 6px;
  background: #057bfa;
  cursor: pointer;
  transition: background 0.2s ease;
}

.logout-btn:hover {
  background: #0469d4;
}

.logout-btn:active {
  background: #0358b8;
}

.logout-btn__icon {
  flex: none;
  width: 17.3px;
  height: 18px;
  color: #fff;
}

.logout-btn__text {
  flex: none;
  font-family: 'WenQuanYi Zen Hei', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #fff;
  white-space: nowrap;
}
</style>
